import ApiRoute from "../api/ApiRoute";
import Urls from "../api/Configuration";
import ServersResponse from "../api/dtos/server/ServersResponse";
import ServiceLocator from "./ServiceLocator";
import { ServerRequest } from "../api/dtos/server/ServerRequest";
import EmptyApiResponse from "../api/dtos/EmptyApiResponse";
import { ServerActionRequest } from "../api/dtos/server/ServerActionRequest";
import ServerResponse from "../api/dtos/server/ServerResponse";
import ServersCardResponse from "../api/dtos/server/ServersCardResponse";

class ServerService {
    public GetServers(applicationId: number): Promise<ServersResponse> {
        return ServiceLocator.ApiClient.Get<ServersResponse>(ApiRoute.Create(Urls.ADMIN_SERVERS)
            .WithParameter('applicationId', applicationId)
            .AsUrl()
        );
    }

    public GetServer(applicationId: number, serverId: number): Promise<ServerResponse> {
        return ServiceLocator.ApiClient.Get<ServerResponse>(ApiRoute.Create(Urls.ADMIN_SERVER)
            .WithParameter('applicationId', applicationId)
            .WithParameter('serverId', serverId)
            .AsUrl()
        );
    }

    public AddServer(applicationId: number, request: ServerRequest): Promise<ServerResponse> {
        return ServiceLocator.ApiClient.Post<ServerResponse>(ApiRoute.Create(Urls.ADMIN_SERVERS)
            .WithParameter('applicationId', applicationId)
            .AsUrl(),
            request
        );
    }

    public RemoveServer(applicationId: number, serverId: number): Promise<EmptyApiResponse> {
        return ServiceLocator.ApiClient.Delete<EmptyApiResponse>(ApiRoute.Create(Urls.ADMIN_SERVER)
            .WithParameter('applicationId', applicationId)
            .WithParameter('serverId', serverId)
            .AsUrl(), null
        );
    }

    public DeployServer(applicationId: number, serverId: number): Promise<EmptyApiResponse> {
        return ServiceLocator.ApiClient.Patch<EmptyApiResponse>(ApiRoute.Create(Urls.ADMIN_SERVER_DEPLOY)
            .WithParameter('applicationId', applicationId)
            .WithParameter('serverId', serverId)
            .AsUrl(), null
        );
    }

    public UpdateServersAction(applicationId: number, request: ServerActionRequest): Promise<EmptyApiResponse> {
        return ServiceLocator.ApiClient.Patch<EmptyApiResponse>(ApiRoute.Create(Urls.ADMIN_SERVERS_ACTION)
            .WithParameter('applicationId', applicationId)
            .AsUrl(),
            request
        );
    }

    public UpdateServerAction(applicationId: number, serverId: number, request: ServerActionRequest): Promise<ServerResponse> {
        return ServiceLocator.ApiClient.Patch<ServerResponse>(ApiRoute.Create(Urls.ADMIN_SERVER_ACTION)
            .WithParameter('applicationId', applicationId)
            .WithParameter('serverId', serverId)
            .AsUrl(), request
        );
    }

    //public
    public GetServersCard(): Promise<ServersCardResponse> {
        return ServiceLocator.ApiClient.Get<ServersCardResponse>(Urls.PUBLIC_SERVERS_CARDS);
    }
}

export default ServerService;
